import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackPixelEvent } from '../../hooks/useMetaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: boolean;
  scrollToOffer?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon = false,
  scrollToOffer = false,
  href,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-serif tracking-wide transition-all duration-300 rounded-sm';
  const variants = {
    primary: 'bg-olive-700 text-white hover:bg-olive-800 shadow-md hover:shadow-lg hover:-translate-y-0.5',
    secondary: 'bg-medBlue-700 text-white hover:bg-medBlue-800 shadow-md hover:shadow-lg hover:-translate-y-0.5',
    outline: 'border-2 border-olive-700 text-olive-700 hover:bg-olive-50'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg font-medium'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      trackPixelEvent('AddToCart');
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (scrollToOffer) {
      document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} onClick={handleClick} {...props} data-id="element-183">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-184" />}
    </motion.button>;
}